(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.enableScroll();
    }

    disconnectedCallback() {
      this.disableScroll();
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-instafeed-5"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (!root || root.dataset.carouselInit === 'true') return;

      const wrapper = root.querySelector('[data-carousel-wrapper]');
      const track = root.querySelector('[data-carousel-track]');
      if (!wrapper || !track) return;

      root.dataset.carouselInit = 'true';

      const direction = wrapper.dataset.direction === 'right' ? 'right' : 'left';
      const velocityDesktop = parseFloat(wrapper.dataset.velocityDesktop) || 80; // seconds to cross one loop
      const velocityMobile = parseFloat(wrapper.dataset.velocityMobile) || 80;
      const pauseOnHover = wrapper.dataset.pauseHover === 'true';

      function isDesktop() {
        return window.innerWidth >= 1024;
      }

      let loopDistance = 0;

      // Measures the real rendered distance between two consecutive item-lists,
      // so the loop always matches however wide the items end up being.
      function measureLoopDistance() {
        const lists = track.querySelectorAll('[data-ss-list]');
        if (lists.length < 2) {
          loopDistance = track.scrollWidth || 1;
          return;
        }
        const first = lists[0].getBoundingClientRect();
        const second = lists[1].getBoundingClientRect();
        const distance = second.left - first.left;
        loopDistance = distance > 0 ? distance : (track.scrollWidth || 1);
      }

      function rebuildTrackCopies() {
        track.querySelectorAll('[data-ss-list="clone"]').forEach((node) => node.remove());

        const baseLists = Array.from(track.querySelectorAll('[data-ss-list="base"]'));
        if (baseLists.length < 1) return;

        // Medimos una sola vez en vez de leer scrollWidth en cada vuelta del
        // bucle — el mismo arreglo de rendimiento que aplicamos en la
        // galería de estilos de tatuajes.
        const baseWidth = track.scrollWidth || 1;
        const targetWidth = wrapper.clientWidth * 2;
        let neededSets = Math.ceil(targetWidth / baseWidth);
        neededSets = Math.max(neededSets, 1);
        neededSets = Math.min(neededSets, 20);

        const fragment = document.createDocumentFragment();
        for (let s = 0; s < neededSets; s++) {
          baseLists.forEach((baseList) => {
            const clone = baseList.cloneNode(true);
            clone.setAttribute('data-ss-list', 'clone');
            clone.setAttribute('aria-hidden', 'true');
            fragment.appendChild(clone);
          });
        }
        track.appendChild(fragment);

        measureLoopDistance();
      }

      function getSpeedPxPerSec() {
        const seconds = isDesktop() ? velocityDesktop : velocityMobile;
        return seconds > 0 && loopDistance > 0 ? loopDistance / seconds : 0;
      }

      function wrapPosition(pos, loop) {
        if (loop <= 0) return 0;
        return ((pos % loop) + loop) % loop;
      }

      let pos = 0; // logical scroll position (unbounded), wrapped for display
      let lastTimestamp = null;
      let isDragging = false;
      let isHovering = false;
      let lastPointerX = 0;
      let dragMoved = false;
      let rafId = null;

      function applyTransform() {
        const wrapped = wrapPosition(pos, loopDistance);
        track.style.transform = 'translate3d(' + (-wrapped) + 'px, 0, 0)';
      }

      function tick(timestamp) {
        if (lastTimestamp === null) lastTimestamp = timestamp;
        const dt = (timestamp - lastTimestamp) / 1000;
        lastTimestamp = timestamp;

        if (!isDragging && !(pauseOnHover && isHovering)) {
          const delta = getSpeedPxPerSec() * dt;
          pos += direction === 'left' ? delta : -delta;
        }

        applyTransform();
        rafId = requestAnimationFrame(tick);
      }

      rebuildTrackCopies();
      rafId = requestAnimationFrame(tick);

      let resizeFrame = null;
      function handleResize() {
        if (resizeFrame) cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(rebuildTrackCopies);
      }
      window.addEventListener('resize', handleResize, { passive: true });

      // --- Drag / swipe support (mouse + touch, via Pointer Events) ---
      function onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isDragging = true;
        dragMoved = false;
        lastPointerX = event.clientX;
        wrapper.classList.add('is-dragging');
        try { wrapper.setPointerCapture(event.pointerId); } catch (e) {}
      }

      function onPointerMove(event) {
        if (!isDragging) return;
        const dx = event.clientX - lastPointerX;
        if (Math.abs(dx) > 2) dragMoved = true;
        lastPointerX = event.clientX;
        pos -= dx;
      }

      function endDrag(event) {
        if (!isDragging) return;
        isDragging = false;
        wrapper.classList.remove('is-dragging');
        if (event && event.pointerId !== undefined) {
          try { wrapper.releasePointerCapture(event.pointerId); } catch (e) {}
        }
      }

      wrapper.addEventListener('pointerdown', onPointerDown);
      wrapper.addEventListener('pointermove', onPointerMove);
      wrapper.addEventListener('pointerup', endDrag);
      wrapper.addEventListener('pointercancel', endDrag);
      wrapper.addEventListener('pointerleave', function (event) {
        if (isDragging) endDrag(event);
      });

      wrapper.addEventListener('mouseenter', function () { isHovering = true; });
      wrapper.addEventListener('mouseleave', function () { isHovering = false; });

      // Avoid accidental link clicks firing right after a real drag
      wrapper.addEventListener('click', function (event) {
        if (dragMoved) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:unload', function (event) {
          if (event.target && event.target.contains(root)) {
            window.removeEventListener('resize', handleResize);
            if (rafId) cancelAnimationFrame(rafId);
          }
        });
      }
    }

    function initAll(scope) {
      const root = scope || document;
      if (root.matches && root.matches('[data-instafeed-carousel]')) {
        initCarousel(root);
      }
      root.querySelectorAll('[data-instafeed-carousel]').forEach(initCarousel);
    }

    initAll(document);

    // Re-init whenever the theme editor reloads this section (e.g. after a settings change)
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
